import StatusPill from '@components/ui/StatusPill';
import { Tooltip } from '@mantine/core';

import { BUNDLE_KIND_LABEL } from './bundleReporting';
import styles from './bundleColumns.module.css';
import type { BundleKind } from './types';

const KIND_TONE: Record<BundleKind, 'neutral' | 'info' | 'warning'> = {
    single: 'neutral',
    multipack: 'warning',
    bundle: 'info',
};

export const BundleKindPill = ({ kind }: { kind: BundleKind }) => (
    <StatusPill label={BUNDLE_KIND_LABEL[kind]} tone={KIND_TONE[kind]} />
);

/** A column header with an explanation on hover. */
export const HeaderHint = ({ label, hint }: { label: string; hint: string }) => (
    <Tooltip label={hint} multiline w={260} withArrow>
        <span className={styles.headerHint}>{label}</span>
    </Tooltip>
);
